import Langs from "../../utils/data/langs.json";
import YoutubeEmbed from "./youtube";
import { RatingStars } from "./ratingStars";
import { Link } from "react-router-dom";
import { getImage } from "../../utils";

const ProfileOverview = ({ id, profile, link = true, showStats = true, isPublic = false }) => {
    const getLangName = (key) => {
        return Langs.find((item) => {
            return item.value == key;
        })?.name;
    };

    const LangTag = ({ lang }) => {
        return lang.name?.trim() !== "" && lang.level?.trim() !== "" ? (
            <div className="flex items-end gap-[5px] rounded-[5px] bg-[#eee]">
                <span className="px-[5px] py-0 text-sm font-medium text-nt-blue">{getLangName(lang.lang)}</span>
                <span className="rounded-br rounded-tr bg-nt-grey px-1.5 py-0.5 text-xs font-light text-white">
                    {lang.level}
                </span>
            </div>
        ) : (
            ""
        );
    };

    return (
        <div className="flex flex-col rounded-[10px] bg-white p-5">
            <div className="flex items-center justify-between max-xl:flex-col max-xl:gap-2.5">
                <div className="flex w-full flex-col justify-between gap-2.5">
                    <div className="flex gap-3">
                        <div className="shrink-0 [&_img]:rounded-full">
                            <img
                                src={getImage(profile.userId.avatar?.path, "AVATAR")}
                                className="h-[100px] w-[100px] object-cover"
                                alt=""
                            />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-2.5 [&_h3]:text-nt-blue [&_h3_img]:ml-2.5 [&_h3_img]:inline">
                            <h3 className="capitalize">
                                {profile.userId.firstName + " " + profile.userId.lastName}
                                {profile.userId.country?.length && (
                                    <img
                                        src={`https://flagsapi.com/${profile.userId.country}/shiny/24.png`}
                                        alt=""
                                    />
                                )}
                            </h3>
                            {profile.teach.length ? (
                                <div className="flex items-baseline gap-2.5 max-sm:flex-col">
                                    <div className="text-sm text-nt-grey">Teaches:</div>
                                    <div className="flex flex-row flex-wrap gap-x-5 gap-y-2.5">
                                        {profile.teach.map((lang, i) => {
                                            return <LangTag lang={lang} key={i} />;
                                        })}
                                    </div>
                                </div>
                            ) : null}
                            {profile.speak.length ? (
                                <div className="flex items-baseline gap-2.5 max-sm:flex-col">
                                    <div className="text-sm text-nt-grey">Speak:</div>
                                    <div className="flex flex-row flex-wrap gap-x-5 gap-y-2.5">
                                        {profile.speak.map((lang, i) => {
                                            return <LangTag lang={lang} key={i} />;
                                        })}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="font-bold text-nt-blue">{profile.teach[0].price + " € | Course"}</div>
                    {showStats ? (
                        <ul className="mx-auto my-5 flex w-full flex-wrap justify-between gap-1 text-sm text-nt-blue lg:text-base xl:gap-5 md:flex-nowrap">
                            <li className="w-[48%] border-e-2 md:w-full">
                                <span className="font-bold ">
                                    Reviews <span className="font-light">({profile.globalReviews.count})</span>
                                </span>
                                <RatingStars active={profile.globalReviews.stars} />
                            </li>
                            <li className="w-[48%] md:w-full md:border-e-2">
                                <span className="font-bold ">Lessons</span>
                                <p>{profile.lessons | 0}</p>
                            </li>
                            <li className="w-[48%] border-e-2 md:w-full">
                                <span className="font-bold ">Students</span>
                                <p>{profile.students | 0}</p>
                            </li>
                            <li className="w-[48%] md:w-full">
                                <span className="font-bold ">Attendance</span>
                                <p>{profile.attendance && profile.attendance != 0 ? profile.attendance + "%" : "100%"}</p>
                            </li>
                        </ul>
                    ) : (
                        ""
                    )}
                </div>
                <div className="[&_iframe]:h-[168px] [&_iframe]:w-[300px]">
                    {profile.youtube?.length ? <YoutubeEmbed url={profile.youtube} /> : ""}

                    {link && (
                        <Link
                            to={isPublic ? "/public/tutor/" + profile._id : "/tutor/" + profile._id}
                            className="mt-5 block w-full self-center rounded bg-nt-blue px-4 py-2 text-center text-white no-underline"
                        >
                            View Profile
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export { ProfileOverview };
